import React from 'react';
import { motion } from 'framer-motion';
import type { SlideProps } from './SlideShell';
export function Slide01Title({
  index
}: SlideProps) {
  return <div className="relative w-full h-full overflow-hidden bg-white" data-id="element-56" data-mp="1eydizxe69xp6">
      {/* Hero image */}
      <div className="absolute inset-0" data-id="element-57" data-mp="102xhj7b9izir">
        <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/91219c59-3b06-4353-b2d2-2ca5926bfb97.jpg" alt="" role="presentation" className="w-full h-full object-cover opacity-70" initial={{
        scale: 1.05
      }} animate={{
        scale: 1
      }} transition={{
        duration: 10,
        ease: 'easeOut'
      }} data-id="element-58" data-mp="151qzbbxl1coq" />
        <div className="absolute inset-0 bg-white/55" data-id="element-59" data-mp="mc2be2s5ewiv" />
      </div>

      {/* Top accent */}
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      delay: 0.1,
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute top-0 left-0 right-0 h-2 bg-[var(--brand)] origin-left z-20" data-id="element-60" data-mp="8ct2zpa6p6pg" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(5rem,9vh,7rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-61" data-mp="2eh75yiauabg4">
        <div className="max-w-4xl" data-id="element-62" data-mp="29icbgj3ieyg6">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25,
          duration: 0.6
        }} className="flex items-center gap-4 mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-63" data-mp="1lr6vm3xkk65v">
            <span className="h-px w-12 bg-[var(--brand)]" data-id="element-64" data-mp="130yzw6w78hzp" />
            <p className="text-[var(--brand)] text-[clamp(0.85rem,1.3vw,1.1rem)] font-bold uppercase tracking-[0.25em]" data-id="element-65" data-mp="12ze4kf228v0s">
              Campaign Strategy
            </p>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.7
        }} className="text-[var(--fg)] font-bold text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.05] tracking-tight mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-66" data-mp="1rs4yb827qp7o">
            <span className="text-[var(--brand)]" data-id="element-67" data-mp="18ubt1z44a374">Established Brands</span>
            <br data-id="element-68" data-mp="1dru723wzr8lz" />
            Campaign Strategy
          </motion.h1>

          {/* Subline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.6
        }} className="text-[var(--muted)] text-[clamp(1.1rem,1.8vw,1.6rem)] font-medium max-w-3xl leading-snug mb-[clamp(2rem,4vw,3rem)]" data-id="element-69" data-mp="1ir6p8bcx3ri8">
            Interactive frequent HCP campaigns for the established brand
            portfolio, built from reusable master assets.
          </motion.p>
        </div>
      </div>

      {/* Footer row */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 flex items-center justify-end gap-4" data-id="element-70" data-mp="3tlz41y5wyzt">
        <span className="px-4 py-1.5 bg-white border border-black/10 text-[var(--fg)] text-xs font-bold rounded-full uppercase tracking-wider shadow-sm" data-id="element-71" data-mp="3h1fgqckav9f1">
          Established Brands
        </span>
      </motion.div>
    </div>;
}